/**
 * Sage and Co. — scroll reveal
 *
 * The base theme fades every .global__section in on page load over 3s, so
 * sections far down the page finish animating long before anyone scrolls to
 * them. component-ui-polish.css shortens that load fade; this file gives
 * below-the-fold sections a reveal tied to when they actually come into view.
 *
 * Fail-safe by design: the hiding styles require BOTH the .js-ui-reveal class
 * on <html> and a [data-ui-reveal] attribute on the section, and both are only
 * ever set here. If this script does not run, nothing is hidden.
 */
(function () {
  'use strict';

  var REVEAL_ATTR = 'data-ui-reveal';
  var REVEALED_CLASS = 'is-revealed';

  if (!('IntersectionObserver' in window)) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches) return;

  function init() {
    var sections = document.querySelectorAll('.global__section');
    if (!sections.length) return;

    var root = document.documentElement;
    var viewportHeight = window.innerHeight;
    var candidates = [];

    // Only sections that start entirely below the fold. Anything already on
    // screen — the hero above all — must never be hidden, or we would delay
    // the LCP element behind an observer callback. Entirely matters: at the
    // old 0.9x threshold a section straddling the fold could have its top few
    // pixels painted, then visibly flash out when this tagged it hidden.
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].getBoundingClientRect().top > viewportHeight) {
        candidates.push(sections[i]);
      }
    }

    if (!candidates.length) return;

    root.classList.add('js-ui-reveal');

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          entries[i].target.classList.add(REVEALED_CLASS);
          observer.unobserve(entries[i].target);
        }
      },
      // Deliberately no negative rootMargin and a zero threshold: a section
      // reveals the instant any part of it enters the viewport. A negative
      // bottom margin would shrink the trigger zone, and the last section on a
      // short page can only ever reach the very bottom of the viewport — it
      // would never cross the line and would stay invisible for good. Erring
      // toward triggering early is the only safe direction here.
      { rootMargin: '0px', threshold: 0 }
    );

    for (var j = 0; j < candidates.length; j++) {
      candidates[j].setAttribute(REVEAL_ATTR, '');
      observer.observe(candidates[j]);
    }

    // Long-stop. Hidden content that never comes back is far worse than a
    // missed animation, so if anything is still un-revealed after 10s of
    // reading time, show it unconditionally. Covers any case where the
    // observer never delivers (suppressed callbacks, a layout that keeps a
    // section out of the viewport, an exception upstream).
    var revealAll = function () {
      observer.disconnect();
      var pending = document.querySelectorAll('[' + REVEAL_ATTR + ']');
      for (var k = 0; k < pending.length; k++) {
        pending[k].classList.add(REVEALED_CLASS);
      }
    };
    window.setTimeout(revealAll, 10000);

    // If the visitor turns on reduced motion mid-session, drop everything
    // rather than leaving un-revealed sections stuck at opacity 0.
    var onPreferenceChange = function () {
      if (!reduceMotion.matches) return;
      observer.disconnect();
      root.classList.remove('js-ui-reveal');
    };

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', onPreferenceChange);
    } else if (typeof reduceMotion.addListener === 'function') {
      reduceMotion.addListener(onPreferenceChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
